<template>
  
  <div style="width: 200px; height: 200px;">
    <canvas id="myChart2" width="200" height="200"></canvas>
  </div>

</template>

<script>
import Chart from "chart.js/auto";
export default {
  name: "transaction-module-chart",

  props: { chartData: [] },
  data() {
    return {
      chart: null,
      options: {
        animationSteps : 100,
        animationEasing : "easeOutBounce",
        animateRotate : true,
        animateScale : false,
        responsive: true,
        maintainAspectRatio: true,
        showScale: true,
        animateScale: true,
        borderWidth: 0,

        legend: {
          display: false,
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            enabled: false,
          },
        },

        hover: {
          mode: false,
        },
      },
    };
  },
  watch: {
    chartData: function(val) {
      this.chart.data = this.fillData();
      this.chart.update();
    },
  },
  mounted() {
    const ctx = document.getElementById("myChart2").getContext("2d");
    this.chart = new Chart(ctx, {
      type: "doughnut",
      data: this.fillData(),
      options: this.options,
    });
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    fillData() {
      return {
        datasets: [
          {
            circumference: 360,
            backgroundColor: [
              "#1395ba",
              "#0f5b78",
              "#d94e1f",
              "#ef8b2c",
              "#ebc844",
              "#a2b86c",
            ],
            data: this.chartData,
          },
        ],
      };
    },
  },
};
</script>

<style></style>
